import { activitySendDelay } from 'config'
import { useVisibility } from 'domains/visibility/hooks'
import { className } from 'lib/css'
import { useCallback, useRef } from 'preact/hooks'
import {
  useSeamlyCommands,
  useSeamlyIdleDetachCountdown,
} from 'ui/hooks/seamly-hooks'
import { actionTypes } from 'ui/utils/seamly-utils'
import SeamlyActivityEventContext from './seamly-activity-event-context'

const SeamlyActivityMonitor = ({ children }) => {
  const { isMinimized } = useVisibility()
  const prevSendTimestamp = useRef(0)
  const { sendAction } = useSeamlyCommands()
  const { hasCountdown, isActive, stopCountdown } =
    useSeamlyIdleDetachCountdown()

  const onActivityHandler = useCallback(() => {
    if (isMinimized) {
      return
    }

    const timeStamp = new Date().getTime()

    const sendActive = () => {
      sendAction({ type: actionTypes.interactivityUpdate })
      prevSendTimestamp.current = timeStamp
    }

    if (hasCountdown && isActive) {
      sendActive()
      stopCountdown()
    }

    if (timeStamp - prevSendTimestamp.current > activitySendDelay) {
      sendActive()
    }
  }, [sendAction, hasCountdown, isActive, stopCountdown, isMinimized])

  // It is important to use keyUp here as focus may be set from outside the
  // chat container via keyboard. In this case the keyDown handler would not
  // be fired inside the container on the initial focus event.
  return (
    <div
      className={className('activity-monitor')}
      tabIndex={-1}
      onMouseDown={onActivityHandler}
      onKeyUp={onActivityHandler}
      onTouchStart={onActivityHandler}
      onMouseMove={onActivityHandler}
      onWheel={onActivityHandler}
      onPointerDown={onActivityHandler}
      onPointerMove={onActivityHandler}
    >
      <SeamlyActivityEventContext.Provider value={onActivityHandler}>
        {children}
      </SeamlyActivityEventContext.Provider>
    </div>
  )
}

export default SeamlyActivityMonitor
